import { HTMLAttributes, useState } from "react"
import { WorkspaceHomeTertiaryItem } from "../WorkspaceHomeTertiaryItem"
import * as Icons from "@nova/component-icons"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { initializeCenterModalForComponentAction } from "features/content-overlay/slice"
import { ModalNames } from "features/modals/types"
import { WorkspaceHomeSectionTitle } from "../WorkspaceHomeSectionTitle"
import { openWorkspaceShareModal } from "features/data-management/workspace/context/thunks"
import { WorkspaceHomeCTAAlt } from "../WorkspaceHomeCTAAlt"
import { DateFormat, formatDate } from "@nova/format"
import { selectIsDomainWhiteListed, selectUserLicense } from "user/profile/selectors"
import { Licenses } from "@nova/constants"
import { useWorkspacePermissions } from "features/data-management/workspace/useWorkspacePermissions"
import { useRouter } from "pages"
import { showGlobalModal } from "runlevel/actions"
import {
    useActivateProjectWithImmediateModal,
    useActiveFolder,
    useCreateProject,
} from "features/data-management/workspace/context/navigation"

export const WorkspaceHomeGetMoreSection = ({
    isFirstLogin,
    ...rest
}: { isFirstLogin: boolean } & HTMLAttributes<HTMLDivElement>) => {
    const dispatch = useAppDispatch()
    const isWhitelisted = useAppSelector(selectIsDomainWhiteListed)
    const currentLicense = useAppSelector(selectUserLicense)
    const currentLicenseType = currentLicense?.subscriptionType || Licenses.Lite
    const activeFolder = useActiveFolder()
    const createProject = useCreateProject()
    const [isLoadingProject, setIsLoadingProject] = useState(false)
    const { isEditor } = useWorkspacePermissions()
    const router = useRouter("/workspace/:workspaceId")

    const activateWelcomeProject = useActivateProjectWithImmediateModal(
        ModalNames.TryOurAddOnsModal
    )

    const createSampleProject = (name: string) => {
        setIsLoadingProject(true)
        createProject({
            preventSwitchingOfWorkspaceMode: true,
            name,
            callback: async (project) => {
                await activateWelcomeProject(project.id)
                setIsLoadingProject(false)
            },
        })
    }

    return (
        <div {...rest}>
            <WorkspaceHomeSectionTitle className="mt-10" title="Get more out of Nova" />

            {currentLicenseType === Licenses.Lite &&
                !isFirstLogin &&
                !isWhitelisted &&
                isEditor && (
                    <WorkspaceHomeCTAAlt
                        className="mb-6"
                        Icon={<Icons.Icon Icon={Icons.Lightbulb} className="text-lazeryellow" />}
                        title="Try our Features & Tools"
                        onClick={() =>
                            createSampleProject(
                                `Demo - ${formatDate({ value: new Date().toString(), format: DateFormat.MMMDDYYYY })}`
                            )
                        }
                        isLoading={isLoadingProject}
                        disabled={isLoadingProject}
                        loadingText="Creating a Demo Project"
                    />
                )}

            <div className="flex flex-col gap-1">
                {isEditor && activeFolder && (
                    <WorkspaceHomeTertiaryItem
                        title="Invite to workspace"
                        Icon={Icons.Share}
                        onClick={() => dispatch(openWorkspaceShareModal(activeFolder.id))}
                    />
                )}

                {isEditor && (
                    <WorkspaceHomeTertiaryItem
                        title="Set up your workspace"
                        Icon={Icons.Gear}
                        onClick={() => router.navigate({ path: "/settings/configuration" })}
                    />
                )}

                <WorkspaceHomeTertiaryItem
                    title="Explore subscriptions"
                    Icon={Icons.Star}
                    onClick={() => {
                        dispatch(
                            initializeCenterModalForComponentAction(ModalNames.LicenseCheckoutModal)
                        )
                        dispatch(showGlobalModal())
                    }}
                />
            </div>
        </div>
    )
}
